"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Avatar = _interopRequireDefault(require("../Avatar"));

var _Notifications = _interopRequireDefault(require("./Notifications"));

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _Button = _interopRequireDefault(require("../Button"));

var _Icon = _interopRequireWildcard(require("../Icon"));

require("./ProfileMenu.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** The label is always used on text inputs (textareas) and don’t depend on the placeholder text. */
function ProfileMenu(_ref) {
  var image = _ref.image,
      name = _ref.name,
      email = _ref.email,
      editText = _ref.editText,
      onEdit = _ref.onEdit,
      logoutText = _ref.logoutText,
      onLogout = _ref.onLogout,
      withEdit = _ref.withEdit,
      withAlert = _ref.withAlert,
      notifications = _ref.notifications,
      additionalInfo = _ref.additionalInfo,
      rest = _objectWithoutProperties(_ref, ["image", "name", "email", "editText", "onEdit", "logoutText", "onLogout", "withEdit", "withAlert", "notifications", "additionalInfo"]);

  var isNotificationsEmpty = !!notifications.errorMessage || Array.isArray(notifications.data) && notifications.data.length === 0;
  var Avatar = image ? /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    src: image,
    className: "avatar",
    role: "button",
    tabIndex: 0
  }) : /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    className: "avatar",
    role: "button",
    tabIndex: 0,
    name: name
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "profile-menu"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alert-icon-wrapper"
  }, withAlert && /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    placement: "bottomRight",
    overlayClassName: "notifications-menu__Popover",
    title: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: "alert ".concat(isNotificationsEmpty ? 'alert-empty' : ''),
      type: _Icon.ICON_TYPE_BELL_FILLED,
      role: "button",
      tabIndex: 0
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "profile-menu__notification"
  }, /*#__PURE__*/_react.default.createElement(_Notifications.default, notifications)))), /*#__PURE__*/_react.default.createElement(_Dropdown.default, _extends({
    placement: "bottomRight",
    title: Avatar
  }, rest, {
    overlayClassName: "profile-menu__Popover"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "profile-menu__content"
  }, Avatar, /*#__PURE__*/_react.default.createElement("p", {
    className: "profile-menu__name"
  }, name), email && /*#__PURE__*/_react.default.createElement("p", {
    className: "profile-menu__email"
  }, email), additionalInfo && /*#__PURE__*/_react.default.createElement("p", {
    className: "profile-menu__additional"
  }, additionalInfo), withEdit && /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    type: "secondary",
    onClick: onEdit
  }, editText), /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    className: "logout-button",
    onClick: onLogout
  }, logoutText))));
}

ProfileMenu.propTypes = {
  /** The avatar image */
  image: _propTypes.default.string,

  /** The person's name */
  name: _propTypes.default.string,

  /** The person's email */
  email: _propTypes.default.string,

  /** Additional text */
  additionalInfo: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.node),

  /** Button text (default set to 'Edit profile') */
  editText: _propTypes.default.string,

  /** Link text (default set to 'Logout') */
  logoutText: _propTypes.default.string,

  /** Whether edit will be shown */
  withEdit: _propTypes.default.bool,

  /** Whether alert will be shown */
  withAlert: _propTypes.default.bool,

  /** The callback function that is triggered when the edit button is clicked */
  onEdit: _propTypes.default.func,

  /** The callback function that is triggered when the logout button is clicked */
  onLogout: _propTypes.default.func,
  notifications: _propTypes.default.shape({
    data: _propTypes.default.arrayOf(_propTypes.default.shape({
      subject: _propTypes.default.string,
      date: _propTypes.default.string,
      text: _propTypes.default.string
    })),
    onReadNotification: _propTypes.default.func,
    errorMessage: _propTypes.default.string,
    emptyMessage: _propTypes.default.string
  })
};
ProfileMenu.defaultProps = {
  image: '',
  name: undefined,
  email: undefined,
  additionalInfo: null,
  editText: 'Edit profile',
  logoutText: 'Logout',
  withEdit: false,
  withAlert: false,
  onEdit: function onEdit() {},
  onLogout: function onLogout() {},
  notifications: {
    data: [],
    onReadNotificationL: function onReadNotificationL() {},
    errorMessage: null,
    emptyMessage: null
  }
};
var _default = ProfileMenu;
exports.default = _default;